<template lang="pug">
router-view(v-cloak)
</template>

<style lang="stylus">
@import '~@/assets/styles/foundation/_variables.styl'
@import '~@/assets/styles/foundation/_reset.styl'
@import '~@/assets/styles/foundation/_base.styl'
@import '~@/assets/styles/component/_txt.styl'
@import '~@/assets/styles/vendor/_wp.styl'
@import '~@/assets/styles/vendor/_nanoscroller.styl'
@import '~@/assets/styles/vendor/_nanoscroller-ex.styl'

</style>


<script>
import $ from 'jquery'
import { defineComponent, computed, ref, reactive , provide , inject , onMounted, onUpdated, onUnmounted ,watch} from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import gsap from 'gsap'
import Util from './lib/util'

export default defineComponent({
  components:{},

  setup(props, context) {
    
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    onMounted( async ()=>{
      console.log('App onMounted START')
      
      gsap.defaults({overwrite:true})
      
      //初回初期化
      //ブラウザ状態
      store.browser.init()

      //debug状態の初期化
      store.ui.initDebug()

      //preview状態の初期化
      store.api.initPreview()

      //季節の初期設定
      store.ui.initSeason()

      //仏（cookie）の初期設定
      store.ui.initHotoke()

      //チュートリアル（cookie）の初期設定
      store.ui.initTutorial()

      //固定マップオブジェクトを取得
      await store.api.initMapData()

      //初回にスポット一覧を取得
      await store.api.initSpots()

      //init完了まで数秒待つ
      await Util.sleep(800)
      store.ui.state.init = true

      console.log('App onMounted END')
    })

    watch(
      ()=> [store.ui.state.meta.title],
      (value) => {
        const title = value[0]
        $('title').text(title)
      }
    )


    return{
      store
    }
  }
})
</script>
